module.exports = "<header>\n  <app-navbar></app-navbar>\n</header>\n"